import * as React from 'react';
import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import { TooltipComponent } from '@/components/common/tooltip';
import clsx from 'clsx';
import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/24/solid';
import { UseFieldArrayRemove, UseFieldArraySwap } from 'react-hook-form';
import { useNotification } from '@/hooks';
import { QuestionType } from '@/interfaces';

interface LandingActionQuestionI {
	index: number;
	totalQuestions: number;
	remove: UseFieldArrayRemove;
	swap: UseFieldArraySwap;
	questionType: QuestionType;
}

export const LandingActionQuestion: React.FC<LandingActionQuestionI> = ({
	index,
	totalQuestions,
	swap,
	remove,
	questionType,
}) => {
	const { toastInfo } = useNotification();

	const handleMoveDown = () => {
		if (totalQuestions > index + 1 && totalQuestions > 1) {
			swap(index, index + 1);
		}
	};

	const handleMoveUp = () => {
		if (totalQuestions > index && totalQuestions > 1 && index > 0) {
			swap(index, index - 1);
		}
	};

	const dirQuestion: Record<QuestionType, string> = {
		YES_NO: 'Yes/No',
		TEXT: 'Short Answer',
		DATE: 'Date',
		MULTIPLE: 'Multiple Choice',
	};

	return (
		<div className="flex items-center justify-between mb-6">
			<div className="flex items-center gap-2">
				<div className="bg-primary size-6 rounded-full flex items-center justify-center">
					<Typography type="bold-16" className="text-white">
						{index + 1}
					</Typography>
				</div>
				<Typography type="semibold-14">{dirQuestion[questionType]}</Typography>
			</div>
			<div className="flex items-center gap-x-6">
				<TooltipComponent
					label="Delete the question"
					className="w-fit"
					trigger={
						<button
							type="button"
							onClick={() => {
								remove(index);
								toastInfo('Question deleted');
							}}
						>
							<Icon src={Icons.trash} className="text-[#707070] !size-5" />
						</button>
					}
				/>
				<TooltipComponent
					label="Move the question down."
					className="w-fit"
					trigger={
						<button
							type="button"
							className={clsx({
								'opacity-30':
									totalQuestions === 1 || totalQuestions === index + 1,
							})}
							onClick={handleMoveDown}
						>
							<ArrowDownIcon className="text-[#707070] !size-5" />
						</button>
					}
				/>
				<TooltipComponent
					label="Move the question up"
					className="w-fit"
					trigger={
						<button
							type="button"
							className={clsx({
								'opacity-30': totalQuestions === 1 || index === 0,
							})}
							onClick={(e) => {
								e.preventDefault();
								handleMoveUp();
							}}
						>
							<ArrowUpIcon className="text-[#707070] !size-5" />
						</button>
					}
				/>
			</div>
		</div>
	);
};
